import { INIT_MESSAGE, CONVERSATION_ERROR, RECEIVE_MESSAGE, UPDATE_CONVERSATION_LIST, LOAD_INIT_MESSAGE } from 'actions/conversation-messages';
import { SET_ACTIVE_CONVERSATION } from 'actions/conversations';
import { MESSAGES_SUCCESS } from 'actions/messages';

export default (() => {
  const initialState = {
    rooms: {},
    error: null,
    loading: false,
    activeConversation: null,
  };

  return (state = initialState, action) => {
    switch (action.type) {
      case LOAD_INIT_MESSAGE:
        return {
          ...state,
          loading: true,
        };
      case INIT_MESSAGE:
        return !state.rooms[action.payload.room]
          ? {
              ...state,
              loading: false,
            }
          : {
              ...state,
              loading: false,
              rooms: {
                ...state.rooms,
                [action.payload.room]: {
                  ...state.rooms[action.payload.room],
                  messages: {
                    ...action.payload.result,
                    data: action.payload.result.data.reverse(),
                  },
                },
              },
            };
      case SET_ACTIVE_CONVERSATION:
        return {
          ...state,
          activeConversation: action.room,
          loading: false,
        };
      case UPDATE_CONVERSATION_LIST:
        return {
          ...state,
          loading: false,
          activeConversation:
            action.payload.switchRoom && action.payload.owner === action.payload.currentUser ? action.payload.id : state.activeConversation,
          rooms: action.payload.messages
            ? {
                ...state.rooms,
                [action.payload.id]: {
                  id: action.payload.id,
                  date: action.payload.updatedAt,
                  messages: {
                    data: action.payload.messages,
                    hasNext: false,
                  },
                  participants: action.payload.participants,
                },
              }
            : { ...state.rooms },
        };
      case RECEIVE_MESSAGE:
        return !state.rooms[action.payload.room]
          ? {
              ...state,
              loading: false,
            }
          : {
              ...state,
              loading: false,
              activeConversation:
                action.payload.switchRoom && action.payload.user && action.payload.owner === (action.payload.currentUser || action.payload.user.id)
                  ? action.payload.room
                  : state.activeConversation,
              rooms: {
                ...state.rooms,
                [action.payload.room]: {
                  ...state.rooms[action.payload.room],
                  date: action.payload.updatedAt,
                  messages: {
                    ...state.rooms[action.payload.room].messages,
                    data: [...state.rooms[action.payload.room].messages.data, action.payload.result],
                  },
                },
              },
            };
      case CONVERSATION_ERROR:
        return {
          ...state,
          loading: false,
          error: {
            code: action.payload.code,
            message: action.payload.message,
          },
        };
      // handle prev messages action
      case MESSAGES_SUCCESS:
        return {
          ...state,
          loading: false,
          rooms: {
            ...state.rooms,
            [action.response.conversationId]: {
              ...state.rooms[action.response.conversationId],
              messages: {
                ...action.response,
                data: [...action.response.data.reverse(), ...state.rooms[action.response.conversationId].messages.data],
              },
            },
          },
        };
      default:
        return state;
    }
  };
})();
